module.exports = __webpack_public_path__ + "img/hero-products.ac479fd4.png";